import { render, staticRenderFns } from "./BrEmptyBanner.vue?vue&type=template&id=b9a43b9c&"
import script from "./BrEmptyBanner.vue?vue&type=script&lang=js&"
export * from "./BrEmptyBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports